import * as React from "react";
import { forwardRef } from "react";
const SvgIconNextInactive = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={17} height={17} viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g transform="translate(1 1)" fill="none" fillRule="evenodd"><circle stroke="#1C498E" strokeWidth={0.5} cx={7.5} cy={7.5} r={7.5} /><path fill="#1C498E" fillRule="nonzero" d="M6.504 3 5.5 4.004l3.259 3.259L5.5 10.52l1.004 1.004 4.263-4.262z" /></g></svg>;
const ForwardRef = forwardRef(SvgIconNextInactive);
export { ForwardRef as ReactComponent };